import { useEffect, useState } from "react";
import FlowPage from "./components/FlowPage";
import PhilosophyPage from "./components/PhilosophyPage";
import Hero from "./components/Hero";
import { getPath } from "./router";
import { loadFlowPage, loadPhilosophyPage } from "./flow-loader";

export default function App() {
  // Path state lives in a *component* so JetShake lowers useState → signal.
  // (Custom hooks still call the compat hook runtime under leanBoot.)
  const [path, setPath] = useState(getPath);

  useEffect(() => {
    const onPop = () => setPath(getPath());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  // Warm the content chunks while the page sits idle, so SPA nav swaps
  // instantly instead of waiting on the network. requestIdleCallback must
  // be invoked on window (a detached call throws Illegal invocation).
  useEffect(() => {
    const warm = () => {
      loadFlowPage();
      loadPhilosophyPage();
    };
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(warm);
    } else {
      setTimeout(warm, 1500);
    }
  }, []);

  // Exactly TWO whole-body branches, both host-element returns, page picked
  // by an inline ternary. Three sibling `if` returns make the compiler emit
  // the first branch as a raw jsx() descriptor (not lowered DOM) and skip its
  // effects - the lean root then mounts nothing on that route. See
  // tasks/bugs/open/BUG-COMPILER-020.
  if (path === "/how-it-works" || path === "/philosophy") {
    return (
      <div className="page page--flow">
        {path === "/how-it-works" ? <FlowPage /> : <PhilosophyPage />}
      </div>
    );
  }

  return (
    <div className="page">
      <Hero />
    </div>
  );
}
